import React, { useEffect } from "react";
import { Modal } from "react-bootstrap";
import label from "../../labels/accessRightsManagement_en.json";
import { useForm } from "react-hook-form";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { saveNewUserData } from "../../actions/accessRightsManagementActions";
const DeleteUser = (props) => {
  const { register, handleSubmit, formState, watch } = useForm({
    mode: "onChange",
  });
  const dispatch = useDispatch();
  let { userListing } = useSelector(
    (state) => state?.accessRightsManagementReducer,
    shallowEqual
  );
  

  const onSubmit = () => {
    const mappingUser = userListing.userList.map((item, index) =>
    item
  );
  
   const filterUser=mappingUser.filter((ele) => ele.user.id === props.setDeletedData.user.id);

  //  mappingUser.filter((ele) => ele.id === props.setDeletedData.user.id)
    
    const data = {
      "userApproval": {
        approvalType: "Delete User",
        status: "Approval1_Pending",
        userId: filterUser[0].user.id,
        email: props.setDeletedData.user.email,
        mobile: props.setDeletedData.user.mobile,
        password: props.setDeletedData.user.password,
        isActive: props.setDeletedData.user.isActive,
        firstName: props.setDeletedData.user.firstName,
        lastName: props.setDeletedData.user.lastName,
      },
      "userApprovalDeptRoleDto":[]
    };
    dispatch(saveNewUserData(data));
    props.setShowModal(false);
  };
  return (
    <Modal
      size="xs"
      show={props.showModal}
      onHide={() => {
        props.setShowModal(false);
      }}
      aria-labelledby="example-modal-sizes-title-xs"
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title id="example-modal-sizes-title-xs">
          Are you sure you want to delete?
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/* <div className="row"> */}
        <div className="row custom-button text-align-right">
          <button
            className="btn btn-secondary ml-auto mr-2"
            type="button"
            onClick={() => {
              props.setShowModal(false);
            }}
          >
            {label.No}
          </button>
          <button
            className="btn btn-primary"
            onClick={handleSubmit((e) => {
              onSubmit(e);
            })}
          >
            {label.Yes}
          </button>
        </div>
        {/* </div> */}
      </Modal.Body>
    </Modal>
  );
};

export default DeleteUser;
